import { render, staticRenderFns } from "./ChooseSeatBack.vue?vue&type=template&id=7b34ea60&scoped=true"
import script from "./ChooseSeatBack.vue?vue&type=script&lang=js"
export * from "./ChooseSeatBack.vue?vue&type=script&lang=js"
import style0 from "./ChooseSeatBack.vue?vue&type=style&index=0&id=7b34ea60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b34ea60",
  null
  
)

export default component.exports